var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"h-8 w-12 rounded-md object-cover",attrs:{"src":_vm.image.thumb_url}})}
var staticRenderFns = []

export { render, staticRenderFns }